import { render } from "./FooterBadge.vue?vue&type=template&id=51719d55&scoped=true"
import script from "./FooterBadge.vue?vue&type=script&lang=js"
export * from "./FooterBadge.vue?vue&type=script&lang=js"

import "./FooterBadge.vue?vue&type=style&index=0&id=51719d55&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51719d55"]])

export default __exports__